import React from 'react';
import { connect } from 'react-redux';
import App from '@/components/App';

const AppContainer = ({ user, ...props }) => {
  console.log('user details:', user);

  return <App {...props} user={user} />;
};

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(AppContainer);
